<template>
	<div class="p-grid after-sales" v-if="firstLoad">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <h2>{{ $t('afterSales.title') }}</h2>
    </div>
    <div v-if="selectedModel==null" class="p-col after-sales-model-details-body">
      <p><img src="/assets/irinox/icons/arrow_back.svg" alt="Back" @click="$functions.historyBack()"/> <span style="font-weight: normal;">{{ $t('afterSales.model_not_present') }}</span></p>
    </div>
    <div v-else class="p-grid p-nogutter after-sales-model-details" style="width: 100%;">
      <div class="p-col-fixed after-sales-model-details-image p-text-center" style="width:250px;">
        <img :src="$config.afterSalesAssets('models') + selectedKey + '.png'" :alt="'MODEL'" style="width:250px;" :onerror="'if (!this.src.includes(\'.svg\')) this.src=\''+$config.afterSalesAssets('models') + selectedKey + '.svg\''" />
      </div>
      <div class="p-col after-sales-model-details-body">
        <p><img src="/assets/irinox/icons/arrow_back.svg" alt="Back" @click="$functions.historyBack()"/> {{ selectedLabel }}</p>
        <FavoriteWidget :docTreeId="docTreeId" mode="button" v-if="docTreeId"/>
        <TabView class="irinox-tab p-mt-4" style="width:100%">
          <TabPanel>
            <template #header>
                <div class="p-d-flex p-ai-center p-ml-3 p-mr-1">
                    <div class="icon-afterSales_doc" style="font-size: 20px;"/>
                    <div class="p-ml-2" style="line-height: 1;">{{$t('afterSales.tab_documents')}}</div>
                </div>
            </template>
            <ModelDocuments :documents="documents" :docTreeId="selectedModel?.docTreeId"/>
          </TabPanel>
          <TabPanel v-if="role!=='USER' && $config.sparePartsEnabled()">
            <template #header>
                <div class="p-d-flex p-ai-center p-ml-3 p-mr-1">
                    <div class="icon-afterSales_spareParts" style="font-size: 25px; margin-left: 20px;"/>
                    <div class="p-ml-2" style="line-height: 1;">{{$t('afterSales.tab_spareParts')}}</div>
                </div>
            </template>
            <ModelSpareParts :docTreeId="selectedModel?.docTreeId" />
          </TabPanel>
        </TabView>
      </div>
    </div>

  </div>

  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
</template>

<script>
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
import ModelDocuments from './ModelDocuments.vue';
import ModelSpareParts from './ModelSpareParts.vue';
import FavoriteWidget from './FavoriteWidget.vue';
export default {
  components: { 
    IrinoxDialogDark,
    ModelDocuments,
    ModelSpareParts,
    FavoriteWidget
  },
  data() {
    return {
      docTreeId: this.$window.location.href.includes('/after-sales/tree/') ? Number(this.$route.params.docTreeId) : null,
      modelId: this.$window.location.href.includes('/after-sales/model/') ? Number(this.$route.params.modelId) : null,
      modelDomain: this.$window.location.href.includes('/after-sales/model/') ? this.$route.params.modelDomain : null,
      dialog: {
        error: false,
      },
      documents: [],
      spareParts: [],
      isDev: process.env.NODE_ENV === 'development',
      firstLoad: false,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      docTreeRawDate: 'afterSales/docTreeRawDate',
      favorites: 'afterSales/favorites',
      role: 'userdata/role',
    }),
    selectedModel() {
      if(this.docTreeId) {
        return this.docTreeRaw.find(item => item.docTreeId == this.docTreeId);
      } else if(this.modelId) {
        return this.docTreeRaw.find(item => item.modelIds && item.modelIds.find(model => model === this.modelId));
      } else {
        return null;
      }
    },
    selectedLabel() {
      if(this.selectedModel) {
        for(let i=5; i>=1; i--) {
          if(this.selectedModel['level'+i]) {
            return this.selectedModel['level'+i+'Translation'] || this.selectedModel['level'+i];
          }
        }
      }
      return 'UNKNOWN';
    },
    selectedKey() {
      if(this.selectedModel) {
        for(let i=5; i>=1; i--) {
          if(this.selectedModel['level'+i]) {
            return this.selectedModel['level'+i];
          }
        }
      }
      return 'unknown';
    },
    isFavorite() {
      return this.favorites?.includes(this.docTreeId);
    } 

  },
  watch: {
      '$i18n.locale': 'loadDocTree'
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
    this.loadDocTree();
  },
  methods: {
    loadDocTree() {
      // if(this.docTreeRaw.length>0 && this.docTreeRawDate && this.$moment().diff(this.$moment(this.docTreeRawDate), 'hours') < 1) {
      //   console.log("Load docTree from store");
      //   if(!this.docTreeId) {
      //     this.docTreeId = this.selectedModel ? this.selectedModel.docTreeId : null;
      //   }
      //   this.loadAll();
      // } else {
      //   console.log("Load docTree from API");
      this.$store.commit('afterSales/docTreeRaw', []);
        this.afterSalesService.getDocTree(this.personaltoken, this.$functions.language(this.$i18n.locale))
          .then((data) => {
            if(data.code=="200") {
              this.$store.commit('afterSales/docTreeRaw', data.body);
              if(!this.docTreeId) {
                // CASO DOCUMENTI MACCHINA: filtra docTreeRaw per modelId e dominio; se ne trova più di uno, devo fare redirect alla pagina di scelta del modello
                let modelsFound = this.docTreeRaw.filter(item => item.domain==this.modelDomain && item.modelIds && item.modelIds.find(model => model === this.modelId));
                if(modelsFound.length==0 && this.modelDomain!='STANDARD') { //se non trovo nulla con il dominio specificato, riprovo con STANDARD
                  modelsFound = this.docTreeRaw.filter(item => item.domain=='STANDARD' && item.modelIds && item.modelIds.find(model => model === this.modelId));
                }
                if(modelsFound.length==1) {
                  this.docTreeId = this.selectedModel ? this.selectedModel.docTreeId : null;
                } else if(modelsFound.length>1) {
                  let md = modelsFound[0];
                  this.$store.commit('afterSales/domain', md.domain );
                  let newPath = [md.level1, md.level2, md.level3, md.level4, md.level5].filter(l => l!=null); //tolgo i null
                  newPath.pop(); //tolgo l'ultimo livello (modello)
                  this.$store.commit('afterSales/path', newPath);
                  this.$router.push({ path: `/after-sales` });
                  return;
                }
              }
              if(this.docTreeId) {
                this.loadAll();
              }
            } else {
              console.error(JSON.stringify(data));
              this.$store.commit('afterSales/docTreeRaw', []);
              this.dialog.error = true;
            }
            })
          .catch(error => {
            console.error("ERROR "+error);
            this.$store.commit('afterSales/docTreeRaw', []);
            this.dialog.error = true;
          })
          .finally(() => {
            this.firstLoad = true;
          });
      // }
    },
    async loadAll() {
      try {
        await this.loadFavorites();
        await this.getDocuments();
      } catch(e) {
        console.error("ERROR "+e);
        this.dialog.error = true;
      }
    },
    async loadFavorites() {
      let response = await this.afterSalesService.getFavorites(this.personaltoken);
      if(response.code=="200") {
        this.$store.commit('afterSales/favorites', response.body);
      } else {
        console.error(JSON.stringify(response));
        this.$store.commit('afterSales/favorites', []);
        this.dialog.error = true;
      }
    },
    async getDocuments() {
      let response = await this.afterSalesService.getDocuments(this.personaltoken, this.docTreeId, this.modelId!=null ? "machine_dashboard" : "generic_section");
      if(response.code=="200") {
        this.documents = response.body;
      } else {
        console.error(JSON.stringify(response));
        this.dialog.error = true;
      }
    }
  }
}

</script>

<style scoped>
</style>